
  var _styles = {
  "hot-city-route-block": {
    "position": "relative",
    "width": "50%",
    "marginBottom": "0.16rem"
  },
  "hot-city-route-block-inner-container": {
    "position": "relative",
    "display": "flex",
    "height": "1.65333rem",
    "borderRadius": "0.13333rem",
    "backgroundColor": "rgb(255,255,255)",
    "flexDirection": "row"
  },
  "hot-city-route-block-info": {
    "flex": 4,
    "display": "flex",
    "flexDirection": "column",
    "paddingLeft": "0.26667rem"
  },
  "hot-city-route-block-info-city": {
    "marginTop": "0.34667rem",
    "marginBottom": "0.12rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "hot-city-route-block-info-from-city": {
    "maxWidth": "1.04rem",
    "textAlign": "center",
    "fontSize": "0.34667rem",
    "width": "auto"
  },
  "hot-city-route-block-info-to-city": {
    "maxWidth": "1.04rem",
    "textAlign": "center",
    "fontSize": "0.34667rem",
    "width": "auto"
  },
  "hot-city-route-block-info-duration": {
    "fontSize": "0.26667rem",
    "lineHeight": "0.26667rem",
    "marginBottom": "0.18667rem"
  },
  "hot-city-route-block-price": {
    "flex": 3,
    "borderRadius": "0 0.13333rem 0.13333rem 0",
    "backgroundColor": "rgb(82,197,240)",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "height": "1.65333rem"
  },
  "hot-city-route-block-price-text": {
    "fontSize": "0.4rem",
    "lineHeight": "0.4rem",
    "fontWeight": "500"
  },
  "hot-city-route-block-left-circle": {
    "position": "absolute",
    "top": "50%",
    "width": "0.26667rem",
    "height": "0.26667rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.13333rem",
    "marginTop": "-0.13333rem",
    "left": 0,
    "marginLeft": "-0.16rem"
  },
  "hot-city-route-block-right-circle": {
    "position": "absolute",
    "top": "50%",
    "width": "0.26667rem",
    "height": "0.26667rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.13333rem",
    "marginTop": "-0.13333rem",
    "left": "100%",
    "marginLeft": "-0.10667rem"
  }
};



  module.exports = _styles;
  